<div class="m-1" #gridContainer>
  <pqgrid #loadsGrid [options]="loadsOptions"></pqgrid>
</div>

<app-email-question-form [emailQuestionParameters]="emailQuestionForm" [emailQuestionFormId]="emailQuestionFormId"></app-email-question-form>
